import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const Default = () => {
  const { resource } = useMetaLayoutContext();


  return (
    <div>{`Default: ${resource.id()} ${resource.type()}`}</div>
  );
};

export { Default };
